<div class="header-section header-home-section">
  <div class="container-fluid">
    <div class="row">
      <div class="col col-header-container">
        <!-- LOGO -->
        <a id="header-logo" [routerLink]="setLogoRouterLink()">
          <img class="logo-standard" src="assets/images/logo/cedlab-logo.png" alt="CedLab">
          <img class="logo-small" src="assets/images/logo/cedlab-logo-small.png" alt="CedLab">
        </a>

        <div id="header-menu-toggle">
          <button (click)="toggleMobileMenu()" class="side-header-toggle header-icon"><i
              class="fa fa-bars"></i></button>
        </div>

        <div id="header-right-menu" [ngClass]="{'active': mobileMenuActive}">
          
          <div class="link-item" routerLinkActive="active">
            <a routerLink="/home" (click)="removeMobileMenu()">Home</a>
          </div>
         
          <div class="link-item" routerLinkActive="active"> 
            <a routerLink="/registration" (click)="removeMobileMenu()">Registrati</a>
          </div>
         
          <div class="link-item" routerLinkActive="active"> 
            <a (click)="removeMobileMenu(); signInEventEmit()">Accedi</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
